import { hideLoading, showLoading } from 'redux-store/reducers/loading-reducer';
import { RESET_ALL as RESET_ON_LOGOUT } from 'redux-store/reducers/common-reducer';

import { createReducer } from 'utils/redux';
import { API, get } from 'utils/api';
import { logError } from 'utils/log';

import type { Action, ActiveCampaign, ThunkAction } from 'types';

const CAMPAIGNS_LOADING = 'activeCampaigns/CAMPAIGNS_LOADING';
const CAMPAIGNS_LOADED = 'activeCampaigns/CAMPAIGNS_LOADED';
const CAMPAIGNS_RESET = 'activeCampaigns/CAMPAIGNS_RESET';

const { ADMIN } = API.END_POINTS;

const initialState = {
  campaigns: [],
  isLoading: false
};

function setLoadingStatus(status: boolean): Action {
  return {
    type: CAMPAIGNS_LOADING,
    payload: {
      status
    }
  };
}

function campaignsLoaded(data: Array<ActiveCampaign>): Action {
  return {
    type: CAMPAIGNS_LOADED,
    payload: {
      data
    }
  };
}

export function resetCampaigns(): Action {
  return {
    type: CAMPAIGNS_RESET
  };
}

export function fetchActiveCampaigns(influencerId: number): ThunkAction {
  return (dispatch) => {
    const historicalPeriod = 30;
    const url = ADMIN.getActiveCampaigns(influencerId, historicalPeriod);

    dispatch(resetCampaigns());
    dispatch(setLoadingStatus(true));
    dispatch(showLoading(url));

    return get(url)
      .then((response) => {
        dispatch(campaignsLoaded(response.data));
        dispatch(hideLoading(url));
      })
      .catch((error) => {
        dispatch(setLoadingStatus(false));
        dispatch(hideLoading(url));
        logError(error);
      });
  };
}

export default createReducer<any, any>('adminInfluencerActiveCampaigns', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [CAMPAIGNS_LOADING]: (state, { status }) => ({
    ...state,
    isLoading: status
  }),
  [CAMPAIGNS_LOADED]: (state, { data }) => ({
    ...state,
    campaigns: data,
    isLoading: false
  }),
  [CAMPAIGNS_RESET]: (state) => ({
    ...state,
    campaigns: []
  })
});
